module.exports = __webpack_public_path__ + "static/media/17.8261bf43.jpg";